import { subscribe } from 'diagnostics_channel';

// 落地页课配置 多语言
export const LANDING_CONFIGURABLE_EN = {
  formInformationExists: 'The phone number has been submitted and we will keep in touch with you',
  formPhoneEmpty: 'The mobile number cannot be empty.',
  formPhoneIncorrectFormat: 'Please enter a valid cell phone number',
  formEmailEmpty: 'Email cannot be empty',
  formEmailIncorrectFormat: 'Please enter your valid email',
  formNameEmpty: 'Name cannot be empty',
  formEnglishNameEmpty: 'English name cannot be empty',
  // 扩科 学号为空
  formStudentCodeEmpty: '未查询到学员学号，请联系您的班主任',
  // 扩科 姓名为空
  formStudentNameEmpty: 'Name cannot be empty',
  // 扩科 英文名为空
  formStudentEnglishNameEmpty: 'English name cannot be empty',
  // 扩科 手机号为空
  formStudentPhoneEmpty: 'The mobile number cannot be empty',
  formAge: ' years old',
  formAgeFormat: 'select your child age',
  formAgePlaceholder: 'Age of your child',
  formHomeGradePlaceholder: `Your Child's Grade`,
  formEmpty: 'Cannot be empty',
  formPrivacy: 'WuKong will protect the personal privacy of each student.',
  formLanguagePlaceholder: 'Preferred contact language (not class)',
  formLanguageEmpty: 'Please choose your preferred language',
  formVerificationCodePlaceholder: 'Verification Code',
  formVerificationCodeFormat1: 'Please enter verification code',
  formVerificationCodeFormat2: 'Verification code is 4-digits',
  formVerificationCodeFormat3: 'Please enter your phone number',
  formVerificationCodeGet: 'Send Code',
  formVerificationCodeResend: 'Resend',
  formGradeFormat: 'select your child grade',
  chineseCourseSlogan: 'Online class for 3 to 18 year-old students',
  mathCourseSlogan: "Learn from Home with World's Top Teachers",
  englishCourseSlogan: 'Master the art of reading and writing',
  resultsPageCongratulate: 'Obtain<span class="hide-pc"><br /></span><span> Success!</span>',
  resultsPageTitle: 'Congratulations on obtaining',
  resultsPageChineseCourse: 'FREE 1-on-1 Chinese Trial Class ',
  resultsPageMathCourse: 'WuKong Online Math Trial Class',
  resultsPageEnglishCourse: 'Honor Reading and Writing Class',
  resultsPageTelephoneContact: 'Our teacher will contact with you through phone calls in the next 2 days',
  resultsPageTelephoneUnblocked: 'Please wait patiently, and keep your phone available',
  resultsPageTeacherWechat: 'Scan the QR code ',
  resultsPageUnlockMore: 'to unlock more abundant learning resources',
  resultsPageClassDetails: 'Class Details',
  resultsPageClassName: 'Class Name',
  resultsPageClassTime: 'Date&Time',
  resultsPageTimeZone: 'Time Zone',
  resultsPageGoStudentBookingTitle: 'Schedule your class now! ',
  resultsPageGoStudentBookingInfo: 'Choose a suitable time for your trial class',
  resultsPageGoStudentTitle: 'Start your learning journey',
  resultsPageGoStudentInfo: 'Enter the Learning Center and prepare for your classes',
  resultsPageContactName: 'Academic Advisor',
  resultsPageContactWX:
    'Hi! 👋 I will contact you within 48 hours, so please keep your phone available.😊 If you have any questions, scan the QR code to add my WeChat:',
  resultsPageContactEmail:
    "Hi! 👋 I will contact you within 48 hours, so please keep your phone available.😊 If you have any questions, don't hesitate to contact me directly via email at: ",
  resultsPageContactWX2:
    'Your exclusive course consultant will contact you within 48 hours, so please keep your phone available.',
  resultsPageScan: 'Scan the QR code to get more learning resources.',
  loading: 'loading...',
  retry: 'Click to retry',
  pageTitle: 'WuKong Education Online Class',
  additionalAcquisition: 'Extra Gift',
  verifySlideFixedTitle: 'Please complete the safety verification',
  verifySlideFixedInfo: 'Swipe to right to verify',
  verifySlideFixedFailed: 'Verification failed, please try again.',
  verifySlideFixedSuccess: 'Verification successful！',
  privacyAgreementUser1: 'I have read and accepted the ',
  privacyAgreementUser1b: "I have read and agreed to WuKong's ",
  privacyAgreementUser2: 'Terms of Service',
  privacyAgreementUser3: 'and',
  privacyAgreementUser4: ' Privacy Policy',
  privacyAgreementUser5: '',
  privacyAgreementUser5b:
    ", and consent to provide my child's details, such as age, for matching with the free trial class.",
  agreePrivacyAgreement: 'Please read and agree to the agreement',
  Submitting: '提交中',
  calendarReminder: 'Please complete the required fields.',
  openClassTitle: 'Book Free Class',
  openClassFormCountryTitle: 'Please confirm your time zone',
  openClassFormClassTimeTitle: 'Please select the class time',
  openClassFormEmailTitle: 'Email',
  openClassFormEmailSubTitle: `* We'll send the class confirmation info and pre-class preparation details to your email.`,
  openClassFormBtnSubmit: 'Confirm',
  openClassFormBtnSubmit2: 'Book Now',
  formPleaseEnter: 'Please enter',
  openClassFull: 'FULL',
  openClassDone: 'STARTED',
  openClassName: 'Open Seminar',
  minute: 'mins',
  publicInvokeWechat: 'Add WeChat',
  publicClassStudyPlan:
    "Dear parents, I'm your personal academic advisor. Please add me on WeChat below so I can tailor a study plan just for your child. I'll also give you a call shortly to assist with pre-course preparation.",
  publickClassPlanTeacher: 'Academic Advisor',
  publicClassTitle: 'Booking is confirmed!',
  publicClassSendEmailTips: "The course begins in {day}. We've sent everything you need to know to your email.",
  publicClassClaim1v1Title: 'A free <b>1-on-1 Chinese Language class</b> for you!',
  publicClassClaim1v1Email:
    "Dear parents, I'm your dedicated academic advisor. Please contact me via email at {email} to enroll in 1-on-1 Chinese Language class. I'll also reach out to you by phone shortly to customize a study plan for you.",
  publicClassClaim1v1Detail:
    "Dear parents, I'm your dedicated academic advisor. Please add me on WeChat below to enroll in 1-on-1 Chinese Language class. I'll also reach out to you by phone shortly to customize a study plan for you.",
  publickClassFullyBooked: 'Fully booked',
  // 体验课结果页面
  tcr_owner_appointment_email_description:
    "Hello {name}'s parents! 👋 I'm your dedicated academic advisor. Please contact me via email at {email} or scan the QR code below on WeChat so I can tailor a study plan just for {name}. 😊 I'll also reach out to you by phone shortly to customize a study plan for you.",
  tcr_owner_appointment_enterprise_wx_subject_name_chinese: '1-on-1 Chinese Language class',
  tcr_owner_appointment_enterprise_wx_subject_name_english: 'Live English Language Arts class',
  tcr_owner_appointment_enterprise_wx_subject_name_math: 'Live interactive Math class',
  tcr_owner_appointment_enterprise_wx_remind:
    'The course begins in {day}. Pre-course materials have been emailed to you.',
  tcr_owner_appointment_enterprise_wx_description:
    "  Hello {name}'s parents! 👋 I'm your personal academic advisor. Please add me on WeChat below so I can tailor a study plan just for {name}. 😊 I'll also give you a call shortly to assist with pre-course preparation for you.",
  tcr_owner_no_appointment_qrcode_description:
    "Thank you for choosing WuKong! Your dedicated academic advisor will reach out to you within 48 hours. Keep your phone around, as we'll call to arrange a class that fits your schedule.",
  tcr_owner_no_appointment_qrcode_guide: 'Scan the QR code to unlock more learning resources!',
  tcr_owner_no_appointment_enterprise_wx_chinese: 'Free lesson claimed!',
  tcr_owner_no_appointment_enterprise_wx_english: 'Free lesson claimed!',
  tcr_owner_no_appointment_enterprise_wx_math: 'Free lesson claimed!',
  tcr_owner_no_appointment_enterprise_wx_sub_title: 'Add your Academic Advisor now to schedule your class!',
  tcr_owner_no_appointment_enterprise_wx_description:
    "Dear parents, I'm your dedicated academic advisor. Please contact me by scanning the QR code below on WeChat to enroll in {course}. I'll also reach out to you by phone shortly to customize a study plan for you.",
  tcr_owner_no_appointment_email_description:
    "Dear parents, I'm your dedicated academic advisor. Please contact me via email at {email} or scan the QR code below on WeChat to enroll in {course}. I'll also reach out to you by phone shortly to customize a study plan for you.",
  tcr_appointment_title: "{name}'s booking is confirmed!",
  tcr_no_appointment_title: "{name}'s booking is confirmed!",
  tcr_virtual_tilte: "We've received your preferred time.",
  tcr_virtual_title_with_name: "We've received {name}'s preferred time.",
  tcr_virtual_info_chinese: '1-on-1 Chinese Language class',
  tcr_virtual_info_math: 'Live interactive Math class',
  tcr_virtual_info_english: 'Live English Language Arts class',
  tcr_virtual_owner_wx_description:
    "Hello, {name}'s parents! 👋 I'm your personal academic advisor and I will contact you by phone to assist you in confirming and scheduling the course. 😊 You can also scan the WeChat QR code below to contact me for {name}'s exclusive learning plan.",
  tcr_virtual_owner_email_description:
    "Hello, {name}'s parents! 👋 I'm your dedicated academic advisor and I will contact you by phone to assist you in confirming and scheduling the course. 😊 You can also contact me via email: james.bond@wukongsch.com or scan the QR code below on WeChat, so I can tailor a learning plan for {name}.",
  publicClassStudyPlanEmail: `Dear parents, I'm your dedicated academic advisor. Please contact me via email at {email} so I can tailor a study plan just for {name}. I'll also reach out to you by phone shortly to customize a study plan for you.`,
  server_en_owner_description: `Dear parents, I'm your personal academic advisor. 👋 Please contact me on WeChat or WhatsApp below to enroll in {course}. 😊 I'll also reach out to you by phone shortly to customize a study plan for you.`,
  server_en_booking_name_owner_description: `Hello {name}'s parents! 👋 I'm your personal academic advisor. Please contact me on WeChat or WhatsApp below so I can tailor a study plan just for {name}. 😊 I'll also give you a call shortly to assist with pre-course preparation for you.`,
  server_en_booking_owner_description: `Hello {name}'s parents! 👋 I'm your personal academic advisor. Please contact me on WeChat or WhatsApp below to enroll in {course}. 😊 I'll also reach out to you by phone shortly to customize a study plan for you.`,
  tryAgain: 'Try again later',
  invokeWechat: 'Add WeChat',
  invokeWhatsApp: 'Add WhatsApp',
  WechatName: 'WeChat',
  WuKongAssistant: 'WuKong Assistant',
  addCourseToCalendar: 'Subscribe to the calendar to stay on track with key learning moments.',
  subscribeBtn: 'Subscribe',
  subscribeAction: 'Subscribe to My Calendar',
  subscribeDescPC: 'Use your phone camera to scan the QR code and add the calendar to your phone.',
  subscribeDescMobile:
    'When you subscribe to this calendar, classes will show up automatically, and stay up to date. Your phone will ask you to confirm, then will link with your calendar app.',
  subscribeSuccess: 'Done',
  subscribAsync: 'Subscribe',
  subscribeCancel: 'Cancel',
  // 微信推荐语三段式文案
  wechat_recommendation_header:
    "Hey there! 👋 I'm your child's dedicated advisor. I've put together something special for you:",
  wechat_recommendation_item1: 'One personalized learning plan',
  wechat_recommendation_item2_chinese:
    'Chinese Culture Key Terms: Essential vocabulary copybook for bilingual children',
  wechat_recommendation_item2_math: 'Wukong Math Primer: Fun activities to build early math skills',
  wechat_recommendation_item2_english: "Curated Kids' Reading List: Wonderful books to inspire a love of reading",
  wechat_recommendation_footer_qrcode:
    "Please scan the QR code to contact me and unlock these limited-time benefits. I look forward to supporting your child's growth together!",
  wechat_recommendation_footer_button:
    "Please tap the button below to contact me and unlock these limited-time benefits. I look forward to supporting your child's growth together!",
};
export const LANDING_CONFIGURABLE_ZH = {
  formInformationExists: '登记信息已存在，您无需再次登记。悟空老师会尽快联系您。',
  formPhoneEmpty: '手机号不能为空',
  formPhoneIncorrectFormat: '手机号格式不正确',
  formEmailEmpty: '邮箱不能为空',
  formEmailIncorrectFormat: '邮箱格式不正确',
  formNameEmpty: '姓名不能为空',
  formEnglishNameEmpty: '英文名不能为空',
  // 扩科 学号为空
  formStudentCodeEmpty: '未查询到学员学号，请联系您的班主任',
  // 扩科 姓名为空
  formStudentNameEmpty: '未查询到学员姓名，请联系您的班主任',
  // 扩科 英文名为空
  formStudentEnglishNameEmpty: '未查询到学员英文名，请联系您的班主任',
  // 扩科 手机号为空
  formStudentPhoneEmpty: '未查询到账户手机号，请联系您的班主任',
  formAge: '岁',
  formAgeFormat: '请选择孩子的年龄',
  formAgePlaceholder: '请选择孩子的年龄',
  formHomeGradePlaceholder: '请选择孩子的在读年级',
  formEmpty: '不能为空',
  formPrivacy: '悟空中文会保障每位学员的个人隐私',
  formLanguagePlaceholder: '您倾向的服务语言',
  formLanguageEmpty: '请选择倾向的服务语言',
  formVerificationCodePlaceholder: '请输入验证码',
  formVerificationCodeFormat1: '请输入手机验证码',
  formVerificationCodeFormat2: '请输入4位数字',
  formVerificationCodeFormat3: '请输入手机号码',
  formVerificationCodeGet: '获取验证码',
  formVerificationCodeResend: '重新发送',
  formGradeFormat: '请选择孩子的年级',
  chineseCourseSlogan: '扎下母语的根·立足世界的人',
  mathCourseSlogan: '全球名师数学课，在家就能轻松学',
  englishCourseSlogan: '掌握方法 · 精通读写',
  resultsPageCongratulate: '领取<span>成功!</span>',
  resultsPageTitle: '恭喜您免费获得',
  resultsPageChineseCourse: '1v1悟空名师在线中文体验课',
  resultsPageMathCourse: '全球名师数学体验课',
  resultsPageEnglishCourse: '进阶阅读写作课程',
  resultsPageTelephoneContact: '悟空老师将在两天内与您电话联系',
  resultsPageTelephoneUnblocked: '请耐心等待并保持电话畅通',
  resultsPageTeacherWechat: '立即扫描二维码',
  resultsPageUnlockMore: '解锁更多丰富学习资源',
  resultsPageClassDetails: '课程详情',
  resultsPageClassName: '课程名称',
  resultsPageClassTime: '上课时间',
  resultsPageTimeZone: '当前时区',
  resultsPageGoStudentBookingTitle: '现在就预约上课时间！',
  resultsPageGoStudentBookingInfo: '为您的体验课选择一个合适的时间',
  resultsPageGoStudentTitle: '开启悟空学习之旅',
  resultsPageGoStudentInfo: '前往悟空学员中心，做好课前准备',
  resultsPageContactName: '学习规划师',
  resultsPageContactWX:
    '您好！👋我会在48小时内与您电话联系，请耐心等待，并保持电话通畅。😊如果您有任何问题，可以通过微信联系我：',
  resultsPageContactEmail:
    '家长您好！👋 我是孩子的专属学习规划师。😊  请通过下方联系方式添加我，让我为孩子量身定制学习计划。稍后我也将与您电话联系，协助孩子完成课前准备。',
  resultsPageContactWX2: '悟空老师将在48小时内与您电话联系，请耐心等待，并保持电话通畅',
  resultsPageScan: '立即扫描二维码 解锁更多丰富学习资源',
  loading: '加载中...',
  retry: '点击重试',
  pageTitle: '悟空教育在线直播课',
  additionalAcquisition: '额外获得',
  verifySlideFixedTitle: '请完成安全验证',
  verifySlideFixedInfo: '向右滑动完成验证',
  verifySlideFixedFailed: '验证失败',
  verifySlideFixedSuccess: '验证成功',
  privacyAgreementUser1: '我已阅读并同意',
  privacyAgreementUser1b: '我已阅读并接受WuKong的',
  privacyAgreementUser2: '用户协议',
  privacyAgreementUser3: '和',
  privacyAgreementUser4: '隐私政策',
  privacyAgreementUser5: '',
  privacyAgreementUser5b: '，并同意与WuKong分享我孩子的年龄等信息，为孩子匹配体验课程',
  agreePrivacyAgreement: '请阅读并同意协议',
  Submitting: '提交中',
  calendarReminder: '请先补充上方孩子信息',
  openClassTitle: '公开课约课信息填写',
  openClassFormCountryTitle: '确认所在时区/国家',
  openClassFormClassTimeTitle: '选择上课时间',
  openClassFormEmailTitle: '邮箱地址',
  openClassFormEmailSubTitle: '* 我们将把课程预约及课前准备信息发送到您的邮箱',
  openClassFormBtnSubmit: '确认时间',
  openClassFormBtnSubmit2: '立即预约',
  formPleaseEnter: '请输入',
  openClassFull: '满员',
  openClassDone: '已结课',
  openClassName: '公开课',
  minute: '分钟',
  publicInvokeWechat: '添加微信',
  publicClassStudyPlan:
    '家长您好！我是孩子的专属学习规划师。请通过下方微信添加我，让我为孩子量身定制学习计划。稍后我也将与您电话联系，协助孩子完成课前准备。',
  publickClassPlanTeacher: '学习规划师',
  publicClassTitle: '恭喜您<span>预约成功</span>',
  publicClassSendEmailTips: '课程将在{day}后开课，已将课前准备内容发送至您的邮箱',
  publicClassClaim1v1Title: '您有一节<b>1v1中文私教课</b>待领取！',
  publicClassClaim1v1Email: `家长您好！我是孩子的专属学习规划师。请通过邮件联系我：{email}，领取为孩子准备的1V1中文私教课。稍后我也将与您电话联系，为孩子量身定制学习计划。`,
  publicClassClaim1v1Detail:
    '家长您好！我是孩子的专属学习规划师。请通过下方微信添加我，领取为孩子准备的1V1中文私教课。稍后我也将与您电话联系，为孩子量身定制学习计划。',
  publickClassFullyBooked: '本期课程已约满',
  // 体验课结果页面
  tcr_owner_appointment_email_description:
    '{name}的家长您好! 👋 我是您的专属学习规划师。稍后我将与您电话联系，协助孩子完成课前准备。😊 您也可以通过邮件联系我：{email}，让我为孩子量身定制学习计划。',
  tcr_owner_appointment_enterprise_wx_subject_name_chinese: '中文1v1私教课',
  tcr_owner_appointment_enterprise_wx_subject_name_english: '英文名师直播课',
  tcr_owner_appointment_enterprise_wx_subject_name_math: '数学名师直播课',
  tcr_owner_appointment_enterprise_wx_remind: '课程将在{day}后开课，已将课前准备内容发送至您的邮箱。',
  tcr_owner_appointment_enterprise_wx_description:
    '{name}的家长您好👋 我是孩子的专属学习规划师。稍后我将与您电话联系，协助孩子完成课前准备。您也可以通过下方微信添加我，让我为孩子量身定制学习计划。',
  tcr_owner_no_appointment_qrcode_description:
    '感谢您选择悟空！您的专属学习规划师将会在48h内与您电话联系，为孩子介绍最合适的课程。<br/>请您耐心等待，并保持电话畅通。',
  tcr_owner_no_appointment_qrcode_guide: '立即扫描二维码{quote}解锁更多丰富学习资源',
  tcr_owner_no_appointment_enterprise_wx_chinese: '恭喜您！成功领取中文课！',
  tcr_owner_no_appointment_enterprise_wx_english: '恭喜您！成功领取英文课！',
  tcr_owner_no_appointment_enterprise_wx_math: '恭喜您！成功领取数学课！',
  tcr_owner_no_appointment_enterprise_wx_sub_title: '添加学习规划师预约上课吧',
  tcr_owner_no_appointment_enterprise_wx_description:
    '家长您好！我是孩子的专属学习规划师。请通过下方微信添加我，领取为孩子准备的{course}。稍后我也将与您电话联系，为孩子量身定制学习计划。',
  tcr_owner_no_appointment_email_description:
    '家长您好！我是孩子的专属学习规划师。请通过邮件{email}或扫描下方微信二维码联系我，领取为孩子准备的{course}。稍后我也将与您电话联系，为孩子量身定制学习计划。',
  tcr_appointment_title: '恭喜{name}预约成功！',
  tcr_no_appointment_title: '恭喜{name}预约成功！',
  tcr_virtual_tilte: '意向上课时间登记成功！',
  tcr_virtual_title_with_name: '恭喜{name}意向上课时间登记成功！',
  tcr_virtual_info_chinese: '中文1v1私教课',
  tcr_virtual_info_math: '数学名师直播课',
  tcr_virtual_info_english: '英文名师直播课',
  tcr_virtual_owner_wx_description:
    '{name}的家长您好👋 我是孩子的专属学习规划师。稍后我将与您电话联系，帮助您确认和完成课程预约。您也可以通过下方微信添加我，让我为孩子量身定制学习计划。',
  tcr_virtual_owner_email_description:
    '{name}的家长您好！👋 我是您的专属学习规划师。稍后我将与您电话联系，帮助您确认和完成课程预约。 😊 您也可以通过邮件联系我：{email}，让我为孩子量身定制学习计划。',
  publicClassStudyPlanEmail: `家长您好！我是您的专属学习规划师。请通过邮件{email}联系我，让我为孩子量身定制学习计划。稍后我也将与您电话联系，协助孩子完成课前准备。`,
  server_en_owner_description: `家长您好！👋 我是孩子的专属学习规划师。😊 请通过下方联系方式添加我，领取为孩子准备的{course}。稍后我也将与您电话联系，为孩子量身定制学习计划。`,
  server_en_booking_name_owner_description: `{name}的家长您好！👋 我是孩子的专属学习规划师。😊  请通过下方联系方式添加我，让我为孩子量身定制学习计划。稍后我也将与您电话联系，协助孩子完成课前准备。`,
  server_en_booking_owner_description: `{name}的家长您好！👋 我是孩子的专属学习规划师。😊 请通过下方联系方式添加我，领取为孩子准备的{course}。稍后我也将与您电话联系，为孩子量身定制学习计划。`,
  tryAgain: '稍后再试',
  invokeWechat: '点击添加微信',
  invokeWhatsApp: '点击添加WhatsApp',
  WechatName: '微信',
  WuKongAssistant: '悟空约课助手',
  addCourseToCalendar: '同步日历，不忘关键学习体验。',
  subscribeBtn: '同步',
  subscribeAction: '同步日历',
  subscribeDescPC: '用你手机的相机扫描二维码来添加日历到你的手机日历',
  subscribeDescMobile:
    '当您将课表同步日历后，所有课程的上课时间会同步到您的日历app中，并且会持续自动更新。您的手机会询问您是否确认导入日历，确认后即可在您的日历app中同步。',
  subscribeSuccess: '完成',
  subscribAsync: '同步',
  subscribeCancel: '取消',
  // 微信推荐语三段式文案
  wechat_recommendation_header: '{name}家长您好！👋我是孩子的专属学习规划师，特别为您准备了：',
  wechat_recommendation_item1: '1v1定制学习规划',
  wechat_recommendation_item2_chinese: '海外华裔必备中华文化字帖',
  wechat_recommendation_item2_math: '悟空理财特刊，培养孩子数学思维',
  wechat_recommendation_item2_english: '让孩子爱上阅读的英文书单',
  wechat_recommendation_footer_qrcode: '请扫码添加我，立即为您解锁限时权益。非常期待和您一同见证孩子成长！',
  wechat_recommendation_footer_button: '请点击下方按钮添加我，立即为您解锁限时权益。非常期待和您一同见证孩子成长！',
};

// 落地页功能 配置 CLASS扩科
export const FORM_TYPE_CONFIG_CLASS = {
  useFormDefaultCountryCode: true,
  phoneSelectDataDisabled: true,
  freshStudentInfo: true,
  useExpandSubjectsLabel: true,
  phoneVisible: true,
};

// 落地页功能 配置 CLASS_BOOKING扩科+约课
export const FORM_TYPE_CONFIG_CLASS_BOOKING = {
  useFormDefaultCountryCode: true,
  phoneSelectDataDisabled: true,
  freshStudentInfo: true,
  useExpandSubjectsLabel: true,
  phoneVisible: true,
};

export const FORM_TYPE_CONFIG_DEFAULT = {
  useDefaultCreate: true,
};

export const FORM_TYPE_CONFIG_FORM = {
  useDefaultCreate: true,
};

export const FORM_TYPE_CONFIG_BOOKING = {
  useDefaultCreate: true,
};

// 公开课
export const FORM_TYPE_OPEN_CLASS = {
  useOpenClassCreate: true,
};

// 留资后置 分步骤约课
export const CLASS_AFTER = {
  useDefaultCreate: true,
};

export const FORM_TYPE_CONFIG = {
  CLASS: FORM_TYPE_CONFIG_CLASS,
  CLASS_BOOKING: FORM_TYPE_CONFIG_CLASS_BOOKING,
  DEFAULT: FORM_TYPE_CONFIG_DEFAULT,
  FORM: FORM_TYPE_CONFIG_FORM,
  BOOKING: FORM_TYPE_CONFIG_BOOKING,
  PUBLIC_CLASS_BOOKING: FORM_TYPE_OPEN_CLASS,
  CLASS_AFTER: CLASS_AFTER,
};

// 中文年龄
export const AGE_CHINESE_ZH = [
  {
    label: '1岁',
    value: '1',
  },
  {
    label: '2岁',
    value: '2',
  },
  {
    label: '3岁',
    value: '3',
  },
  {
    label: '4岁',
    value: '4',
  },
  {
    label: '5岁',
    value: '5',
  },
  {
    label: '6岁',
    value: '6',
  },
  {
    label: '7岁',
    value: '7',
  },
  {
    label: '8岁',
    value: '8',
  },
  {
    label: '9岁',
    value: '9',
  },
  {
    label: '10岁',
    value: '10',
  },
  {
    label: '11岁',
    value: '11',
  },
  {
    label: '12岁',
    value: '12',
  },
  {
    label: '13岁',
    value: '13',
  },
  {
    label: '14岁',
    value: '14',
  },
  {
    label: '15岁',
    value: '15',
  },
  {
    label: '16岁',
    value: '16',
  },
  {
    label: '17岁',
    value: '17',
  },
  {
    label: '18岁',
    value: '18',
  },
  {
    label: '18岁以上',
    value: '19',
  },
];
export const AGE_CHINESE_EN = [
  {
    label: '1 year old',
    value: '1',
  },
  {
    label: '2 years old',
    value: '2',
  },
  {
    label: '3 years old',
    value: '3',
  },
  {
    label: '4 years old',
    value: '4',
  },
  {
    label: '5 years old',
    value: '5',
  },
  {
    label: '6 years old',
    value: '6',
  },
  {
    label: '7 years old',
    value: '7',
  },
  {
    label: '8 years old',
    value: '8',
  },
  {
    label: '9 years old',
    value: '9',
  },
  {
    label: '10 years old',
    value: '10',
  },
  {
    label: '11 years old',
    value: '11',
  },
  {
    label: '12 years old',
    value: '12',
  },
  {
    label: '13 years old',
    value: '13',
  },
  {
    label: '14 years old',
    value: '14',
  },
  {
    label: '15 years old',
    value: '15',
  },
  {
    label: '16 years old',
    value: '16',
  },
  {
    label: '17 years old',
    value: '17',
  },
  {
    label: '18 years old',
    value: '18',
  },
  {
    label: 'Over 18 years old',
    value: '19',
  },
];

// 数学年龄
export const AGE_MATH_ZH = [
  {
    label: '1岁',
    value: '1',
  },
  {
    label: '2岁',
    value: '2',
  },
  {
    label: '3岁',
    value: '3',
  },
  {
    label: '4岁',
    value: '4',
  },
  {
    label: '5岁',
    value: '5',
  },
  {
    label: '6岁',
    value: '6',
  },
  {
    label: '7岁',
    value: '7',
  },
  {
    label: '8岁',
    value: '8',
  },
  {
    label: '9岁',
    value: '9',
  },
  {
    label: '10岁',
    value: '10',
  },
  {
    label: '11岁',
    value: '11',
  },
  {
    label: '12岁',
    value: '12',
  },
  {
    label: '13岁',
    value: '13',
  },
  {
    label: '14岁',
    value: '14',
  },
  {
    label: '15岁',
    value: '15',
  },
  {
    label: '15岁以上',
    value: 'over15',
  },
];

export const AGE_MATH_EN = [
  {
    label: '1 year old',
    value: '1',
  },
  {
    label: '2 years old',
    value: '2',
  },
  {
    label: '3 years old',
    value: '3',
  },
  {
    label: '4 years old',
    value: '4',
  },
  {
    label: '5 years old',
    value: '5',
  },
  {
    label: '6 years old',
    value: '6',
  },
  {
    label: '7 years old',
    value: '7',
  },
  {
    label: '8 years old',
    value: '8',
  },
  {
    label: '9 years old',
    value: '9',
  },
  {
    label: '10 years old',
    value: '10',
  },
  {
    label: '11 years old',
    value: '11',
  },
  {
    label: '12 years old',
    value: '12',
  },
  {
    label: '13 years old',
    value: '13',
  },
  {
    label: '14 years old',
    value: '14',
  },
  {
    label: '15 years old',
    value: '15',
  },
  {
    label: 'Over 15 years old',
    value: 'over15',
  },
];

// 英语年龄中文
export const AGE_ENGLISH_ZH = [
  {
    label: '1岁',
    value: '1',
  },
  {
    label: '2岁',
    value: '2',
  },
  {
    label: '3岁',
    value: '3',
  },
  {
    label: '4岁',
    value: '4',
  },
  {
    label: '5岁',
    value: '5',
  },
  {
    label: '6岁',
    value: '6',
  },
  {
    label: '7岁',
    value: '7',
  },
  {
    label: '8岁',
    value: '8',
  },
  {
    label: '9岁',
    value: '9',
  },
  {
    label: '10岁',
    value: '10',
  },
  {
    label: '11岁',
    value: '11',
  },
  {
    label: '12岁',
    value: '12',
  },
  {
    label: '12岁以上',
    value: 'over12',
  },
];

// 英语年龄英文
export const AGE_ENGLISH_EN = [
  {
    label: '1 year old',
    value: '1',
  },
  {
    label: '2 years old',
    value: '2',
  },
  {
    label: '3 years old',
    value: '3',
  },

  {
    label: '4 years old',
    value: '4',
  },
  {
    label: '5 years old',
    value: '5',
  },
  {
    label: '6 years old',
    value: '6',
  },
  {
    label: '7 years old',
    value: '7',
  },
  {
    label: '8 years old',
    value: '8',
  },
  {
    label: '9 years old',
    value: '9',
  },
  {
    label: '10 years old',
    value: '10',
  },
  {
    label: '11 years old',
    value: '11',
  },
  {
    label: '12 years old',
    value: '12',
  },
  {
    label: 'Over 12 years old',
    value: 'over12',
  },
];

export const LANGUAGE_EN = [
  {
    label: '中文',
    value: '中文',
  },
  {
    label: 'English',
    value: '英语',
  },
];

export const LANGUAGE_ZH = [
  {
    label: '中文',
    value: '中文',
  },
  {
    label: 'English',
    value: '英语',
  },
];

// 科目映射-英文
export const SUBJECT_MAP_EN: { [key: string]: string } = {
  MATH: 'Math',
  CHINESE: 'Chinese',
  ENGLISH: 'English',
};

// 科目映射-中文
export const SUBJECT_MAP_ZH: { [key: string]: string } = {
  MATH: '数学',
  CHINESE: '中文',
  ENGLISH: '英文',
};

export const FB_VALUE_MAP: { [key: string]: number } = {
  '3': 500,
  '4': 500,
  '5': 1000,
  '6': 1000,
  '7': 1000,
  '8': 1500,
  '9': 1500,
  '10': 1000,
  '11': 1000,
  '12': 1500,
  '13': 1000,
  '14': 1500,
  '15': 1000,
  '16': 1000,
};

// vbb test
// ads 后台为每一个landing 页建议一个软化事件，ads 会分配一个对应的转化id
export const VBB_VALUE_MAP: { [key: string]: string } = {
  HS2M46pJ: 'V7gcCLCZ6O8YELn1uM8B',
  zGi4FeT1: 'FJY2CJ3I6O8YELn1uM8B',
  avYYn7Gr: 'aunqCI-d8O8YELn1uM8B',
  Cct3JjYT: 'gDZDCOOA7O8YELn1uM8B',
  m1yUzrVY: 'hY5-CI-j8O8YELn1uM8B',
  ZCTvmhPo: 'GbQbCKik8O8YELn1uM8B',
  oke0ldVH: 'VrKyCP6p8O8YELn1uM8B',
  XRYLn0kj: 'VrKyCP6p8O8YELn1uM8B', // only test env for development
};

export const LANDING_DS_SOURCE = 'landing';
